(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dusha-gaba-navigation"] && !Shopify.designMode) return;
  try {
    
  const initializeGabaFilters = () => {
    if (!document.querySelector('.section-dusha-gaba-navigation')) return;
    const form = document.getElementById('FacetFiltersForm');
    const sort = document.getElementById('sort_by');
    if (!form || !sort) return;
    let sortInput = form.querySelector('input[name="sort_by"]');
    if (!sortInput) {
      sortInput = document.createElement('input');
      sortInput.type = 'hidden';
      sortInput.name = 'sort_by';
      form.appendChild(sortInput);
    }
    const syncSort = () => { sortInput.value = sort.value; };
    syncSort();
    sort.addEventListener('change', syncSort);
    form.addEventListener('input', syncSort, true);
    form.addEventListener('submit', syncSort, true);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeGabaFilters, { once: true });
  } else {
    initializeGabaFilters();
  }
  document.addEventListener('shopify:section:load', initializeGabaFilters);
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.section-dusha-gaba-navigation a[data-gaba-tag]');
    if (!link) return;
    const destination = new URL(link.href, window.location.origin);
    const current = new URLSearchParams(window.location.search);
    destination.search = '';
    current.forEach((value, key) => {
      if (key === 'sort_by' || key === 'preview_theme_id' || (link.dataset.gabaTag && key.startsWith('filter.'))) {
        destination.searchParams.append(key, value);
      }
    });
    link.href = destination.href;
  });

  } catch(e) { console.error(e); }
})();
})();
